// src/components/HeroRadar.tsx
//
// Hero visual, matched to the reference: a dark glowing "eclipse" orb at centre,
// faint concentric radar rings, company avatars slowly orbiting the rings (jobs
// being scanned across boards), and two floating info cards — a live "Applied"
// job card and a match-score card. Pure CSS; reduced-motion safe.
import React from "react";
import "../styles/HeroRadar.css";

// The real job boards Sumbitrbuddy searches — the radar is "scanning every
// board in your region," so each orbiting blip is an actual source.
// angle (deg clockwise from top) + radius (% of half-size) + label + accent.
const BLIPS: { a: number; r: number; label: string; c: string }[] = [
  { a: 20, r: 40, label: "In", c: "#60a5fa" },   // Indeed
  { a: 75, r: 36, label: "in", c: "#38bdf8" },    // LinkedIn
  { a: 130, r: 41, label: "Gd", c: "#34d399" },   // Glassdoor
  { a: 185, r: 37, label: "Az", c: "#a855f7" },   // Adzuna
  { a: 240, r: 41, label: "RO", c: "#f59e0b" },   // RemoteOK
  { a: 305, r: 36, label: "Ms", c: "#ec4899" },   // The Muse
];

const HeroRadar: React.FC = () => (
  <div
    className="radar"
    role="img"
    aria-label="Sumbitrbuddy scanning job boards across your region for matches"
  >
    {/* Faint radar rings + orbiting company blips */}
    <div className="radar-field">
      <span className="radar-ring radar-ring-1" />
      <span className="radar-ring radar-ring-2" />
      <span className="radar-ring radar-ring-3" />
      <span className="radar-sweep" />
      <div className="radar-orbit">
        {BLIPS.map((b) => {
          const rad = (b.a * Math.PI) / 180;
          const x = 50 + b.r * Math.sin(rad);
          const y = 50 - b.r * Math.cos(rad);
          return (
            <span
              key={b.label}
              className="radar-blip"
              style={{ left: `${x}%`, top: `${y}%` }}
            >
              <span className="radar-blip-in" style={{ color: b.c }}>
                {b.label}
              </span>
            </span>
          );
        })}
      </div>
    </div>

    {/* Central eclipse orb */}
    <div className="radar-orb">
      <span className="radar-orb-glow" />
    </div>

    {/* Floating "Applied" job card */}
    <div className="radar-card radar-card-job">
      <span className="rc-logo">N</span>
      <span className="rc-job">
        <span className="rc-job-title">Northwind · Product Designer</span>
        <span className="rc-job-meta">
          <span className="rc-dot" /> Applied 2m ago
        </span>
      </span>
    </div>

    {/* Floating match-score card */}
    <div className="radar-card radar-card-score">
      <span className="rc-score-label">Match score</span>
      <span className="rc-score-row">
        <b>94</b>
        <small>/100</small>
        <span className="rc-delta">+12%</span>
      </span>
    </div>
  </div>
);

export default HeroRadar;
